// TicketWeb listing status — timeline scroll of our events, each upcoming one
// marked Listed or with a "Create on TicketWeb" button (the shell events that
// feed ticketmaster.com). Thin wrapper over the shared DistributionListings view.

import DistributionListings from './DistributionListings.jsx';

export default function TicketWebListings() {
  return (
    <DistributionListings
      title="TicketWeb"
      platform="ticketweb"
      listEndpoint="ticketweb/listings"
      actionLabel="Create on TicketWeb"
      actioningLabel="Creating…"
      notConnectedMsg="TicketWeb is not connected. Set TICKETWEB_USER / TICKETWEB_PASS in the server env to see listing status."
      showTicketmasterDiagnostics
    />
  );
}
